import { render, staticRenderFns } from "./goldenldeas-detail.vue?vue&type=template&id=a1851528&scoped=true&"
import script from "./goldenldeas-detail.vue?vue&type=script&lang=js&"
export * from "./goldenldeas-detail.vue?vue&type=script&lang=js&"
import style0 from "./goldenldeas-detail.vue?vue&type=style&index=0&id=a1851528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1851528",
  null
  
)

export default component.exports